<script lang="ts">
    
    import { onDestroy } from "svelte";
    import { fly } from "svelte/transition";
    import { SERVICE_URL } from "../../environment";
    import type { RealTimeEvent } from "../../global";
    import { eventsChannelsFactory } from "../../Services";

    type Achievement = {
        imageUrl: string;
        text: string;
    };

    export let gameId: string;

    const eventsChannel = eventsChannelsFactory.createEventsChannel(`game.${gameId}`);

    let achievement: Achievement;

    onDestroy(() => eventsChannel.destroy());

    eventsChannel.on('figure', onFigure);
    eventsChannel.on('bingo', onBingo);

    function onFigure({ data }: RealTimeEvent): void {
        achievement = {
            imageUrl: createPlayerPictureUrl(data.player.pictureId),
            text: `
                <div>
                    <span class="fw-bold">${data.player.name}</span> ha conseguido una figura    
                </div>
            `,
        };
    }

    function onBingo({ data }: RealTimeEvent): void {
        achievement = {
            imageUrl: createPlayerPictureUrl(data.player.pictureId),
            text: `
                <div>
                    <span class="fw-bold">${data.player.name}</span> ha obtenido <span class="fw-bold">BINFUN</span>    
                </div>
            `,
        };
    }

    function createPlayerPictureUrl(pictureId: string): string {
        return new URL(`picture/${pictureId}`, SERVICE_URL).href;
    }

</script>

<div class="achievements">
    {#if achievement}
    {#key achievement}
    <div class="achievement" in:fly={{ y: -50 }} out:fly={{ y: 50 }}>
        <div class="picture">
            <img src={achievement.imageUrl} alt="">
        </div>
        <div class="text">
            {@html achievement.text}
        </div>
    </div>
    {/key}
    {/if}
</div>

<style lang="scss">

    .achievements {
        height: 4rem;
        width: 100%;
        position: relative;
    }

    .achievement {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }

    .picture {
        width: 4rem;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        z-index: 2;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .text {
        height: 3rem;
        background-color: rgba(255, 255, 255, 0.25);
        flex: 1 1 0;
        border-radius: 1000rem;
        padding-left: 3rem;
        margin-left: -2rem;
        display: flex;
        align-items: center;
    }

</style>
